module.exports = __webpack_public_path__ + "c5fa2260a09967f51cbff545c6857375.svg";